import { z } from 'zod';
/**
 * Preferenze di accessibilità dell'utente (User.a11yPreferences).
 * L'accessibilità è priorità architetturale: queste preferenze sono
 * applicate globalmente dal frontend (classi sul root, media query override).
 */
export const a11yPreferencesSchema = z.object({
    /** Modalità alto contrasto. */
    highContrast: z.boolean().default(false),
    /** Riduci/elimina animazioni (in aggiunta a prefers-reduced-motion). */
    reduceMotion: z.boolean().default(false),
    /** Testo ingrandito. */
    largeText: z.boolean().default(false),
    /** Interfaccia semplificata: meno elementi decorativi, layout lineare. */
    simplifiedUi: z.boolean().default(false),
    /**
     * Modalità ottimizzata per screen reader: annunci più descrittivi,
     * tabelle al posto dei grafici, niente contenuti solo-visivi.
     */
    screenReaderMode: z.boolean().default(false),
});
export const DEFAULT_A11Y_PREFERENCES = a11yPreferencesSchema.parse({});
//# sourceMappingURL=a11y.js.map